export default [
  {
    header: 'finance.finance',
    permission: ['finance_management', 'supervisor'],
    unique_name: 'finance',
  },
  {
    title: 'finance.title',
    route: 'finance',
    icon: 'TrendingUpIcon',
    permission: ['finance_management'],
    unique_name: 'finance',
  },
  {
    title: 'finance.charts',
    route: 'charts',
    icon: 'BarChart2Icon',
    permission: ['finance_management', 'supervisor'],
    unique_name: 'finance-charts',
  },
]